function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState } from 'react';

// TODO :: make sure placeholder works, move to top and shrink on focus
var Textarea = function Textarea(_ref) {
  var _ref$id = _ref.id,
    pId = _ref$id === void 0 ? null : _ref$id,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? null : _ref$placeholder,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? null : _ref$onChange,
    _ref$onFocus = _ref.onFocus,
    onFocus = _ref$onFocus === void 0 ? null : _ref$onFocus,
    _ref$onBlur = _ref.onBlur,
    onBlur = _ref$onBlur === void 0 ? null : _ref$onBlur,
    _ref$titleCase = _ref.titleCase,
    titleCase = _ref$titleCase === void 0 ? false : _ref$titleCase,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  var _useState = useState(pId || uuid()),
    _useState2 = _slicedToArray(_useState, 1),
    id = _useState2[0];
  var toTitleCase = function toTitleCase(str) {
    var lowers = ['a', 'an', 'and', 'as', 'at', 'but', 'by', 'for', 'for', 'from', 'in', 'into', 'is', 'near', 'nor', 'of', 'on', 'onto', 'or', 'the', 'to', 'with'];
    var uppers = ['U.S.', 'USA'];
    return str.split(' ').map(function (x, i) {
      if (i === 0) return x.charAt(0).toUpperCase() + x.substr(1).toLowerCase();else if (lowers.includes(x.toLowerCase())) return x.toLowerCase();else if (uppers.includes(x.toUpperCase())) return x.toUpperCase();else return x.charAt(0).toUpperCase() + x.substr(1).toLowerCase();
    }).join(' ');
  };
  var handleOnChange = function handleOnChange(e) {
    if (titleCase) e.target.value = toTitleCase(e.target.value);
    if (onChange) onChange(e);
  };
  var handleOnFocus = function handleOnFocus(e) {
    if (onFocus) onFocus(e);
  };
  var handleOnBlur = function handleOnBlur(e) {
    if (onBlur) onBlur(e);
  };
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: "input-text ".concat(className)
  }, /*#__PURE__*/React.createElement("textarea", {
    id: "".concat(id, "-input"),
    value: value,
    style: style,
    disabled: disabled,
    onChange: handleOnChange,
    onFocus: handleOnFocus,
    onBlur: handleOnBlur,
    placeholder: placeholder
  }));
};
export default Textarea;